<template>
  <div class="md-input-container" :class="[themeClass, classes]">
    <slot></slot>

    <span class="md-count" v-if="enableCounter">{{ inputLength }} / {{ counterLength }}</span>

    <md-button
      tabindex="-1"
      class="md-icon-button md-toggle-password"
      @click.prevent="togglePasswordType"
      v-if="mdHasPassword"
    >
      <md-icon :mdSvg="showPassword ? mdiEyeOff : mdiEye" />
    </md-button>

    <md-button tabindex="-1" class="md-icon-button md-clear-input" @click="clearInput" v-if="mdClearable && hasValue">
      <md-icon :mdSvg="mdiClose" />
    </md-button>
  </div>
</template>

<style lang="scss" src="./mdInputContainer.theme"></style>
<style lang="scss" src="./mdInputContainer.scss"></style>

<script>
import { defineComponent } from 'vue';
import theme from '../../core/theme/mixins';
import isArray from '../../core/utils/isArray';
import { mdiClose, mdiEyeOff, mdiEye } from '@mdi/js';

export default defineComponent({
  name: 'md-input-container',
  props: {
    mdInline: Boolean,
    mdFixedLabel: Boolean,
    mdHasPassword: Boolean,
    mdClearable: Boolean,
  },
  mixins: [theme],
  data() {
    return {
      value: '',
      input: false,
      inputInstance: null,
      showPassword: false,
      enableCounter: false,
      hasSelect: false,
      hasPlaceholder: false,
      hasFile: false,
      isDisabled: false,
      isRequired: false,
      isFocused: false,
      counterLength: 0,
      inputLength: 0,
      mdiClose,
      mdiEyeOff,
      mdiEye,
    };
  },
  computed: {
    hasValue() {
      if (isArray(this.value)) {
        return this.value.length > 0;
      }

      if (Number.isSafeInteger(this.value)) {
        return true;
      }
      return Boolean(this.value);
    },
    classes() {
      return {
        'md-input-inline': this.mdInline,
        'md-has-password': this.mdHasPassword,
        'md-clearable': this.mdClearable,
        'md-has-select': this.hasSelect,
        'md-has-file': this.hasFile,
        'md-has-value': this.hasValue || this.mdFixedLabel,
        'md-input-placeholder': this.hasPlaceholder,
        'md-input-disabled': this.isDisabled,
        'md-input-required': this.isRequired,
        'md-input-focused': this.isFocused,
      };
    },
  },
  methods: {
    isInput() {
      return this.input && this.input.tagName.toLowerCase() === 'input';
    },
    togglePasswordType() {
      if (this.isInput()) {
        if (this.input.type === 'password') {
          this.input.type = 'text';
          this.showPassword = true;
        } else {
          this.input.type = 'password';
          this.showPassword = false;
        }

        this.input.focus();
      }
    },
    clearInput() {
      this.inputInstance.$el.value = '';
      this.inputInstance.$emit('update:modelValue', '');
      this.setValue('');
    },
    setValue(value) {
      this.value = value;
    },
  },
  mounted() {
    this.input = this.$el.querySelectorAll('input, textarea, select, .md-file')[0];

    if (!this.input) {
      // this.$destroy();

      throw new Error('Missing input/select/textarea inside md-input-container');
    }
  },
});
</script>
